import React from 'react'

import {
  Footer,
  NotFoundView,
  RouteProps,
  useUserProfile,
} from '@sketch/modules-common'

import { WorkspaceProfileLayout } from '../containers/WorkspaceProfileLayout'
import { ProfileInfo } from '../components/ProfileInfo'
import CommunityHeader from '../components/CommunityHeader'
import PublicViewHiddenProfileBanner from '../components/PublicViewHiddenProfileBanner'

import { useGetWorkspaceProfile } from '../hooks/useGetWorkspaceProfile'
import { LoadingPage } from '@sketch/modules-common/src/components/LoadingPage/LoadingPage'

interface WorkspaceProfilePublicViewProps
  extends RouteProps<'WORKSPACE_PROFILE'> {}

const WorkspaceProfilePublicView = (props: WorkspaceProfilePublicViewProps) => {
  const { shortUrlName } = props.match.params

  const profileResult = useGetWorkspaceProfile({
    variables: { shortUrlName },
  })

  const { data } = useUserProfile()
  const user = data?.me

  if (profileResult.loading) {
    return <LoadingPage />
  }

  if (profileResult.error || !profileResult.profile) {
    return <NotFoundView />
  }

  const { profile } = profileResult

  const workspaceIdentifier = profile.workspace.identifier
  const isAdmin = profile.workspace.userRole === 'ADMIN'
  const isProfilePublic = profile.isPublic === true
  const showHiddenProfileBanner = isAdmin && !isProfilePublic

  return (
    <>
      {showHiddenProfileBanner && workspaceIdentifier && (
        <PublicViewHiddenProfileBanner workspaceId={workspaceIdentifier} />
      )}

      <CommunityHeader user={user} />
      <WorkspaceProfileLayout
        workspaceId={workspaceIdentifier!}
        isProfileEditRoute={false}
        profile={profile}
        profileInfo={<ProfileInfo profile={profile} />}
      />

      <Footer />
    </>
  )
}

export default WorkspaceProfilePublicView
